import classNames from 'classnames';
import React from 'react';
// import PasswordStrengthBar from 'react-password-strength-bar';

import LocaleService from '@services/LocaleService';
import { CheckIcon } from '@shared/icons';

import './PasswordStrengthFeedback.scss';

interface IPasswordStrengthFeedback {
  password?: string;
}

// const scoreWords = [
//   'Very Weak',
//   'Weak',
//   'Fair',
//   'Good',
//   'Strong',
// ];

function PasswordStrengthFeedback({ password = '' }: IPasswordStrengthFeedback) {
  const i18n = LocaleService.getTranslations('general');
  // const [ passwordScore, setPasswordScore ] = useState(0);

  // const handleChangePasswordScore = (score: number) => {
  //   setPasswordScore(score);
  // };

  const isValidLength = password.length >= 8;
  const isValidCase = /[A-Z]/.test(password);
  const isValidNumber = /[0-9]/.test(password);
  // include all special characters except a-z and 0-9
  const isValidChar = /[^A-Za-z0-9]/.test(password);

  return (
    <div className="password-strength-feedback b3">
      {/* <PasswordStrengthBar
        password={password}
        minLength={7}
        shortScoreWord=""
        scoreWordClassName="d-none"
        className="password-strength-bar"
        barColors={[ 'var(--bs-gray-200)', 'var(--bs-danger)',
        'var(--bs-warning)', 'var(--bs-teal)', 'var(--bs-green)' ]}
        onChangeScore={handleChangePasswordScore}
      />
      <div className="mt-3">
        Password Strength:&nbsp;
        <span className={classNames({
          [`password-score-${passwordScore}`]: true,
        })}
        >
          {scoreWords[passwordScore]}
        </span>
      </div> */}
      <div className="mt-3">
        <div className={classNames({
          'password-text-muted': !isValidLength,
          'password-text-success': isValidLength,
          'mb-2': true,
        })}
        >
          <CheckIcon className="me-2" fill={!isValidLength ? '' : '#0F6C30'} />
          {i18n.validation.password.charactersLength}
        </div>
        <div className={classNames({
          'password-text-muted': !isValidCase,
          'password-text-success': isValidCase,
          'mb-2': true,
        })}
        >
          <CheckIcon className="me-2" fill={!isValidCase ? '' : '#0F6C30'} />
          {i18n.validation.password.mixedUpperLowercase}
        </div>
        <div className={classNames({
          'password-text-muted': !isValidNumber || !isValidChar,
          'password-text-success': isValidNumber && isValidChar,
          'mb-2': true,
        })}
        >
          <CheckIcon className="me-2" fill={!isValidNumber || !isValidChar ? '' : '#0F6C30'} />
          {i18n.validation.password.mixedCharacters}
        </div>
        {/* <div className={classNames({
          'password-text-muted': !isValidChar,
          'password-text-success': isValidChar,
          'mb-2': true,
        })}
        >
          <CheckIcon className="me-2" fill={!isValidChar ? '' : 'var(--bs-success)'} />
          At least 1 special character (!@#$%^&*()_+)
        </div> */}
      </div>
    </div>
  );
}

export default PasswordStrengthFeedback;
